import { Component, Output, EventEmitter} from "@angular/core";
import { NavController, NavParams, ViewController, AlertController} from "ionic-angular";
import { AnmeldungenPage } from "../anmeldungen-page/anmeldungen-page";

@Component({
    selector: 'add-athlete',
    templateUrl: 'add-athlete.html',
})

export class AddAthletePage{
@Output() athleteEvent = new EventEmitter<any>();
athleteData = {
    firstName: '',
    lastName: '',
    bibNo: '',
    time: '',
    eventId: 0
};
eventId: number;



constructor(private navCtrl: NavController, 
    private navParams: NavParams, 
    private viewCtrl: ViewController,
    private alertCtrl: AlertController){
    this.getData();
}

getData(){
    this.eventId = this.navParams.get("eventId");
}
addNewAthlete(){
    if(this.athleteData.firstName.length !== 0){
        this.athleteData.eventId = this.eventId;
        this.viewCtrl.dismiss(this.athleteData);
    }
    else{
        let alert = this.alertCtrl.create({
            title: 'Please, add athlete name',
            buttons: ['Okay']
        });
        alert.present();
    }
}
onBackMenu(){
    this.viewCtrl.dismiss(this.athleteData);
}

}


// WEBPACK FOOTER //
// /src/pages/add-athlete/add-athlete.ts